<template>

	<div class="index">

		<!-- 图说时政弹出框 -->
		<el-dialog :title="tsszTitle" :visible.sync="centerDialogVisible" width="65%" center>
			<!-- 图片部分 -->
			<div class="dialog_box_tssz">
				<div class="dialog_pic">
					<img :src="tsszSrc" alt="">
				</div>
			</div>
		</el-dialog>
		<!-- banner图 -->
		<div class="banenr mySwiper5">
			<div class="swiper-wrapper">
				<div class="swiper-slide"  >
					<img @click="goXsx" src="../../assets/xiangning/home/home_banner.png">
				</div>
				<div class="swiper-slide"  >
					<img @click="gocftl" src="../../assets/xiangning/home/home_bannner_cf.png">
				</div>
			</div>
			<div class="swiper-pagination swiper-pagination5"></div>
			
		</div>
		<div class="home_wrap">
			<!-- 新闻中心 -->
			<div class="news">
				<div class="whyr_content_left_pic">
					<!-- 轮播图 -->
					<div class="swiper mySwiper">
						<div class="swiper-wrapper">
							<div @click="goBannerDetail(item)" class="swiper-slide" v-for="item in home_banner">
								<img :src="item.sz_img" alt="">
								<div class="whyr_content_left_pic_title">
									<div class="whyr_content_left_pic_title_title">{{ item.title }}
									</div>
								</div>
							</div>

						</div>
						<div class="swiper-pagination"></div>
					</div>
				</div>
				<div class="news_right">
					<!-- 新闻中心标题-->
					<Title titleName="新闻中心" titleNameEnglish="new Center" @goDetail="goNews('/news', 'xwzx')">
					</Title>
					<!-- 新闻中心内容部分 -->
					<div class="whyr_content">
						<div class="whyr_content_right_content">
							<!-- 文化育人右侧标题 -->
							<div class="share_title2">
								<span v-if="!item.center" v-for="item in newsTitle" :style="{
			color: NewsNum == item.id ? '#C81C1D' : '#666666',
			fontWeight: NewsNum == item.id ? '800' : '400'
		}" @click="changeNewsNum(item.id)">{{ item.title }}
								</span>
								<div v-else="item.center" class="center"></div>

							</div>
							<!-- 党建要闻 -->
							<div class="whyr_right_content">
								<div @click="goBannerDetail(item)" class="whyr_right_content_item"
									v-for="item in topList">
									<div class="left_circle"></div>
									<div class="center_title">{{ item.title }}</div>
									<div class="right_time" style="width: 67px;">{{ item.pub_time }}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 最新推荐 -->
			<div class="newest" v-if="$store.state.user.userinfo2.id">
				<Title titleName="精品党课" @goDetail="goNews('/jpdk', 'jpdk')">
				</Title>
				<div class="newest_content">
					<div class="dataList_item" @click="gozxtjDetail(item)" v-for="item in home_zxtj">
						<div class="dataList_item_top_img">
							<img :src="item.sz_img" alt="">
						</div>
						<div class="dataList_item_bottom">
							<!-- 上方标题 -->
							<div class="dataList_item_bottom_top_title">{{ item.title }}</div>
							<!-- 下方课程信息 -->
							<div class="dataList_item_bottom_botom">
								<div class="dataList_item_bottom_botom_item">
									<div class="dataList_item_bottom_botom_item_content">
										{{ item.addtime }}
									</div>
								</div>
								<div class="dataList_item_bottom_botom_item">
									<div class="dataList_item_bottom_botom_item_icon">
										<img src="../../assets/xiangning/djxx/icon_2.png" alt="">
									</div>
									<div class="dataList_item_bottom_botom_item_content">
										{{ item.nums }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 政策解读/党建百科 -->
			<div class="InterpretationAndResources">
				<!-- 政策解读 -->
				<div class="Interpretation">
					<!-- 标题 -->
					<Title titleName="政策解读" titleNameEnglish="Policy Interpretation"
						@goDetail="goNews('/zcjd', 'zcjd')">
					</Title>
					<!-- 内容 -->
					<div class="Interpretation_content">
						<div class="shizheng_right_item" @click="goTzggDetail(item.id, 'zcjd')"
							v-for="item in home_zcjd" :key="item.id">
							<div class="top_day">
								<span>{{ item.pub_time.substring(5, 10) }}</span>
								<div class="day_bottom"></div>
							</div>
							<div class="center_title">
								{{ item.title }}
							</div>
							<div class="bottom_content">
								{{ item.content }}
							</div>

						</div>
					</div>
				</div>
				<!-- 党建百科 -->
				<div class="home_djbk">
					<!-- 标题 -->
					<Title titleName="党建百科" titleNameEnglish="Encyclopedia" @goDetail="goNews('/djbk', 'djbk')">
					</Title>
					<!-- 内容 -->
					<div class="dangjian_right_content">
						<!-- 人物图片 -->
						<div class="dangjian_right_content_pic">
							<img src="../../assets/xiangning/home/home_people.png" alt="">
						</div>
						<div @click="goDjbk(item.id)" v-for="item in home_djbk" :key="item.id"
							class="dangjian_right_content_item">
							<div class="left_icon"></div> {{ item.title }}
						</div>
					</div>
				</div>
			</div>
			<!-- 工作专区/图解党建/图说时政 -->
			<div class="home_center_three">
				<!-- 工作专区 -->
				<div class="home_center_three_item">
					<!-- 标题 -->
					<Title titleName="工作专区" titleNameEnglish="Illustrate Current Politics" @goDetail="goTssz">
					</Title>
					<div class="gzzq_content" @click="goPage">
						<!-- 三会一课 -->
						<div class="gzzq_content_item" @click="goGzzqDetail('/zzsh')">
							<img src="../../assets/xiangning/home/shyk.png" alt="">
						</div>
						<div class="gzzq_content_item">
							<!-- 党务公开 -->
							<div class="gzzq_content_bottom" @click="goGzzqDetail('/dwgk', 'dwgk')">
								<img src="../../assets/xiangning/home/dwgk.png" alt="">
							</div>
							<!-- 通知公告 -->
							<div class="gzzq_content_bottom" @click="goGzzqDetail('/tzgg', 'tzgg')">
								<img src="../../assets/xiangning/home/tzgg.png" alt="">
							</div>
							<!--党建宣传 -->
							<router-link :target="$store.state.user.userinfo2.id ? '_blank' : ''"
								class="gzzq_content_bottom"
								:to="$store.state.user.userinfo2.id ? { path: '/djxc', query: { user_id: user_id, flag: flag, } } : ''">
								<img src="../../assets/xiangning/home/djxc.png" alt="">
							</router-link>
						</div>
						<div class="gzzq_content_item gzzq_content_item2">
							<div class="gzzq_content_bottom" @click="goGzzqDetail('/djgj', 'djgj', 1)">
								<img src="../../assets/xiangning/home/djdd.png" alt="">
							</div>
							<div @click="goGzzqDetail('/djgj', 'djgj', 2)" class="gzzq_content_bottom">
								<img src="../../assets/xiangning/home/fwhz.png" alt="">
							</div>
							<div @click="goGzzqDetail('/djgj', 'djgj', 3)" class="gzzq_content_bottom">
								<img src="../../assets/xiangning/home/ywfz.png" alt="">
							</div>

							<router-link :target="$store.state.user.userinfo2.id ? '_blank' : ''"
								class="gzzq_content_bottom"
								:to="$store.state.user.userinfo2.id ? { path: '/rdsc', query: { user_id: user_id, flag: flag, } } : ''">
								<img src="../../assets/xiangning/home/rdsc.png" alt="">
							</router-link>

						</div>
					</div>
				</div>
				<!-- 图说时政 -->
				<div class="home_center_three_item">
					<!-- 标题 -->
					<Title titleName="图说时政" titleNameEnglish="Illustrate Current Politics" @goDetail="goTssz">
					</Title>
					<!-- 内容 -->
					<div class="tssz_content">
						<div class="swiper mySwiper" style="height: 226px;">
							<div class="swiper-wrapper">
								<div class="swiper-slide" @click="tsszDetail(item)" v-for="item in home_tssz">
									<img :src="item.sz_img" alt="">
									<div class="tssz_content_title">
										{{ item.title }}
									</div>
								</div>

							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
				</div>
				<!-- 图解党建 -->
				<div class="home_center_three_item">
					<!-- 标题 -->
					<Title titleName="图解党建" titleNameEnglish="Illustrated Party Building"
						@goDetail="goNews('/tjdj', '')">
					</Title>
					<div class="Building">
						<div class="Building_item">
							<div class="swiper mySwiper" style="height: 100%;">
								<div class="swiper-wrapper">
									<div class="swiper-slide" @click="goTjdjDetail(item.id)"
										v-for="(item, index) in home_tjdj" v-if="index < 5">
										<img :src="item.img" alt="">
									</div>

								</div>
								<div class="swiper-pagination"></div>
							</div>
						</div>
						<div class="Building_item">
							<div class="swiper mySwiper" style="height: 100%;">
								<div class="swiper-wrapper">
									<div class="swiper-slide" @click="goTjdjDetail(item.id)"
										v-for="(item, index) in home_tjdj" v-if="index > 4">
										<img :src="item.img" alt="">
									</div>
								</div>
								<div class="swiper-pagination"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Swiper from 'swiper';
import { shouye } from '@/axios';
import Title from '@/components/title.vue'
import { Message } from 'element-ui'
export default {
	name: 'home',
	data() {
		return {
			tsszSrc: '',
			tsszTitle: '',
			NewsNum: 1,
			home_banner: [],
			newList: [],
			newActive: [],
			thearList: [],
			home_djbk: [],
			home_tssz: [],
			home_tjdj: [],
			home_zxtj: [],
			home_zcjd: [],
			home_dwgk: [],
			user_id: this.$store.state.user.userinfo2.id,
			flag: this.$store.state.user.userinfo2.flag,
			// 弹出框按钮
			centerDialogVisible: false,
			newsTitle: [
				{ id: 1, title: '党建要闻' },
				{ center: true },
				{ id: 2, title: '党建活动' },
				{ center: true },
				{ id: 3, title: '风采展示' },
			],
			topList: []
		}
	},
	components: { Title },
	methods: {
		goPage() {

			if (!this.user_id) {
				Message({
					type: "error",
					message: "请先登录"
				})

			}
		},
		// 工作专区详情
		goGzzqDetail(path, type, class_id) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push(
				{
					path: path,
					query: {
						type: type,
						class_id: class_id
					}
				})
		},
		// 跳转至专题培训详情
		gozxtjDetail(item) {
			this.$router.push({
				path: "/jpdkDetail",
				query: {
					id: item.id,
					flag: item.flag
				}
			})
		},
		goBannerDetail(item) {
			if (item.jump == 1) {
				window.open(item.url)
			} else {
				this.goNewsDetail(item.id, 'djyw', this.NewsNum)
			}

		},
		// 习思想
		goXsx() {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({ path: 'xsx' })
		},
		gocftl(){
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({ path: 'djxxDetail',query:{
				id:174,
				title:'党纪学习',
				one_id:17,
				flag:1
			} })
		},
		// 新闻中心/实践活动
		goNews(path, type, id) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({
				path: path,
				query: {
					type: type,
					class_id: id
				}
			})
		},
		goTssz() {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({
				path: '/tssz',

			})
		},
		//点击新闻中心切换标题
		changeNewsNum(val) {
			let that = this
			that.NewsNum = val
			switch (val) {
				case 1:
					this.topList = that.newList
					break;
				case 2:
					this.topList = that.newActive
					break;
				case 3:
					this.topList = that.thearList
					break;
			}
		},
		//初始化轮播图
		swiper() {
			var swiper = new Swiper(".mySwiper", {
				autoplay: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			});
			
		},
		swiper2() {
			var swiper = new Swiper(".mySwiper2", {
				autoplay: true,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
			});
		},
		// 获取首页数据
		getHomeList() {
			let that = this
			shouye.homelist().then((res) => {
				if (res.code == 200) {
					that.newList = res.data.news

					that.newActive = res.data.activity
					that.thearList = res.data.thear
					that.home_djbk = res.data.djbk
					that.home_tssz = res.data.tssz
					that.home_tjdj = res.data.tjdj

					that.home_banner = res.data.banner
					that.home_zcjd = res.data.zcjd
					that.home_zxtj = res.data.zxtj

					that.topList = res.data.news
					// 初始化轮播图
					this.$nextTick(() => {
						that.swiper()
						that.swiper2()
					})

				}

			})
		},
		// 跳转至新闻详情
		goNewsDetail(data, type, class_id, zy_type) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({
				path: '/xwxq',
				query: {
					id: data,
					type: type,
					class_id: class_id,
					zy_type: zy_type
				}
			})
		},
		// 跳转至通知公告详情
		goTzggDetail(id, type) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({
				path: '/tzgg_detail',
				query: {
					id: id,
					type: type
				}
			})
		},
		tsszDetail(data) {
			this.tsszTitle = data.title
			this.tsszSrc = data.sz_img
			this.centerDialogVisible = true
		},
		// 跳转至图解党建详情
		goTjdjDetail(id) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({
				path: 'tidj_detail',
				query: {
					id: id
				}
			})
		},
		// 跳转至特色资源详情
		goZyDetail(path) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({ path: path })
		},
		// 跳转至党建百科
		goDjbk(id) {
			if (!this.$store.state.user.userinfo2.id) {
				Message({
					type: "error",
					message: "请先登录"
				})
				return false
			}
			this.$router.push({
				path: 'djbk',
				query: {
					class_id: id
				}
			})
		}
	},
	mounted() {
		this.getHomeList()
		var swiper5 = new Swiper(".mySwiper5", {
				autoplay: true,
				pagination: {
					el: ".swiper-pagination5",
					clickable: true,
				},
			});
	},
	created() {
		this.$emit("highLight", 1, "", "", "");
	}
}
</script>
<style lang="scss">
@import '@/common/index.scss';
.swiper-pagination5{
	.swiper-pagination-bullet{
		width: 40px;
		height: 6px;
		border-radius: 8px;
	}
	.swiper-pagination-bullet-active{
		background:#fff;
	}
}
.index {
	.dialog_box_tssz {
		width: 100%;
		// height: 400px;
		display: flex;
		justify-content: center;
	}

	.dialog_pic {
		height: auto;
		width: 80%;
		overflow: hidden;
		display: flex;
		align-items: center;

		img {
			width: 100%;
			height: 100%;
		}
	}

	width: 100%;

	.banenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
			cursor: pointer;
		}

		.resourceBar {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 60px;
			background: rgba(56, 56, 56, .6);

			&_c {
				height: 100%;
				margin: auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: $indexWidth;

				.item {
					font-family: $indexFontTitle;
					display: flex;
					align-items: center;
					height: 100%;
					font-size: 20px;
					color: #fff;

					span:nth-child(1) {
						display: block;
						height: 22px;
						width: 22px;
						margin-right: 7px;

						img {
							width: 100%;
						}
					}
				}
			}
		}
	}

	div {
		box-sizing: border-box;
	}



	.home_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;

		// 新闻
		.news {
			margin-top: 20px;
			width: 100%;
			display: flex;
			justify-content: space-between;
			height: 255px;

			// 轮播图样式
			.whyr_content_left_pic {
				position: relative;
				width: 387px;
				height: 100%;
				overflow: hidden;

				/* 轮播图样式 */
				.swiper {
					width: 100%;
					height: 100%;
					position: relative;

					.swiper-slide {
						border-radius: 4px;
						overflow: hidden;
						text-align: center;
						font-size: 18px;
						background: #fff;
						/* Center slide text vertically */
						display: -webkit-box;
						display: -ms-flexbox;
						display: -webkit-flex;
						display: flex;
						-webkit-box-pack: center;
						-ms-flex-pack: center;
						-webkit-justify-content: center;
						justify-content: center;
						-webkit-box-align: center;
						-ms-flex-align: center;
						-webkit-align-items: center;
						align-items: center;

						img {
							display: block;
							width: 100%;
							height: 100%;
							object-fit: cover;
						}

						.whyr_content_left_pic_title {
							height: 36px;
							width: 100%;
							position: absolute;
							left: 0;
							bottom: 0;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							padding-left: 20px;
							background-color: rgba(0, 0, 0, 0.3);

							.whyr_content_left_pic_title_title {
								width: 80%;
								height: 100%;
								overflow: hidden;
								white-space: nowrap;
								text-overflow: ellipsis;
								font-family: PingFangSC-Regular;
								font-size: 14px;
								font-weight: normal;
								line-height: 36px;
								letter-spacing: 0px;
								color: #FFFFFF;
							}

						}

					}

					.swiper-pagination {
						position: absolute;
						bottom: 16px;
						justify-content: right !important;
						align-items: center !important;
						text-align: right !important;
						color: #fff;

					}

					.swiper-pagination-bullet {
						opacity: 0.4;
						width: 8px !important;
						height: 8px !important;
						background: #FFFFFF !important;
						margin-right: 6px;
						margin-left: 0px !important;
					}

					.swiper-pagination-bullet-active {
						opacity: 1;
						background: #fff !important;
						width: 8px !important;
						height: 8px !important;

					}
				}
			}

			.news_right {
				width: 793px;
				height: 100%;

				.whyr_content {
					margin-top: 15px;
					height: 240px;
					width: 100%;
					display: flex;
					justify-content: space-between;



					// 新闻列表样式
					.whyr_content_right_content {
						width: 796px;
						height: 100%;

						.share_title2 {
							display: flex;
							justify-content: center;
							font-family: PingFangSC-Medium;
							font-size: 16px;
							font-weight: normal;
							text-align: right;
							letter-spacing: 0em;
							color: #666666;

							.center {

								width: 2px;
								height: 30px;
								transform: rotate(30deg);
								opacity: 1;
								background: #C81C1D;
								margin-left: 35px;
								margin-right: 35px;
							}
						}

						.whyr_right_content {
							height: 162px;
							width: 100%;
							overflow: hidden;
							margin-top: 15px;
							display: flex;
							flex-wrap: wrap;
							justify-content: space-between;
							align-content: start;

							.whyr_right_content_item {
								height: 40px;
								width: 384px;
								display: flex;
								align-items: center;
								justify-content: space-between;

								.left_circle {
									height: 8px;
									width: 8px;
									border-radius: 50%;
									background-color: #C81C1D;
								}

								.center_title {
									font-family: PingFangSC-Regular;
									font-size: 14px;

									line-height: 20px;
									letter-spacing: 0px;
									color: #000000;
									margin-right: 40px;
									overflow: hidden;
									height: 20px;
									width: 237px;
									text-overflow: ellipsis;
									white-space: nowrap;
								}

								.center_title:hover {
									color: #EE632B;
									font-weight: 800;
								}

								.right_time {
									font-family: MicrosoftYaHei;
									font-size: 12px;
									font-weight: normal;
									line-height: 20px;
									text-align: right;
									letter-spacing: 0px;
									color: #999999;
								}

							}
						}
					}
				}
			}

		}

		// 图说时政/图解党建/党建百科
		.home_center_three {
			margin-top: 30px;
			margin-bottom: 30px;
			display: flex;
			justify-content: space-between;
			width: 100%;

			.home_center_three_item {
				width: 387px;
				height: 318px;

				img {
					width: 100%;
					height: 100%;
				}

				// 工作专区
				.gzzq_content {
					width: 100%;
					height: 256px;
					margin-top: 20px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;

					.gzzq_content_item {
						width: 100%;
						height: 80px;
						display: flex;
						justify-content: space-between;

						.gzzq_content_center {
							height: 100%;
							width: 187px;
						}

						.gzzq_content_bottom {
							height: 100%;
							width: 123px;
						}
					}

					.gzzq_content_item2 {
						.gzzq_content_bottom {
							width: 89px;
							height: 76px;
						}
					}
				}

				// 图说时政
				.tssz_content {
					margin-top: 20px;
					position: relative;
					width: 100%;
					height: 256px;
					overflow: hidden;
					border-radius: 4px;
					overflow: hidden;

					.swiper-pagination {
						position: absolute;
						bottom: 35px;
						justify-content: center !important;
						align-items: center !important;
						text-align: center !important;
						color: #fff;

					}

					.swiper-pagination-bullet {
						opacity: 0.4;
						width: 8px !important;
						height: 8px !important;
						background: #FFFFFF;
						margin-right: 6px;
						margin-left: 0px !important;
					}

					.swiper-pagination-bullet-active {
						opacity: 1;
						background-color: #fff !important;
						width: 8px !important;
						height: 8px !important;

					}

					.tssz_content_title {
						position: absolute;
						left: 0;
						bottom: -30px;
						width: 100%;
						height: 30px;
						background-color: #EE632B;
						color: #FFFFFF;
						font-family: PingFang SC;
						font-size: 14px;
						font-weight: normal;
						text-align: center;
						letter-spacing: 0px;
						color: #FFFFFF;
						line-height: 30px;

					}
				}

				.swiper-slide img {
					width: 100%;
					height: 100%;
				}

				.Politics {
					width: 100%;
					height: 226px;
					margin-top: 20px;
				}

				.Politics_time {
					width: 100%;
					height: 30px;
					background-color: #EE632B;
					color: #fff;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					text-align: center;
					letter-spacing: 0px;
					line-height: 30px;
					text-align: center;
				}

				// 图解党建
				.Building {
					margin-top: 20px;
					width: 100%;
					height: 256px;
					display: flex;
					justify-content: space-between;

					.Building_item {
						position: relative;
						width: 183px;
						height: 100%;
						border-radius: 4px;
						overflow: hidden;

						.swiper-pagination {
							position: absolute;
							bottom: 10px;
							justify-content: center !important;
							align-items: center !important;
							text-align: center !important;
							color: #fff;

						}

						.swiper-pagination-bullet {
							opacity: 0.4;
							width: 8px !important;
							height: 8px !important;
							background: #FFFFFF;
							margin-right: 6px;
							margin-left: 0px !important;
						}

						.swiper-pagination-bullet-active {
							opacity: 1;
							background-color: #fff !important;
							width: 8px !important;
							height: 8px !important;

						}

						img {
							width: 100%;
							height: 100%;
						}
					}
				}


			}

			.home_center_three_item:nth-child(1) {
				.getMore {
					display: none;
				}
			}
		}

		// 政策解读及特色资源
		.InterpretationAndResources {
			margin-top: 30px;
			margin-bottom: 40px;
			width: 100%;
			height: 342px;
			display: flex !important;
			justify-content: space-between;

			// 政策解读
			.Interpretation {
				width: 793px;
				height: 100%;

				.Interpretation_content {
					width: 100%;
					height: 280px;
					margin-top: 20px;
					display: flex;
					justify-content: space-between;
					align-content: space-between;
					flex-wrap: wrap;

					.shizheng_right_item {
						position: relative;
						height: 134px;
						width: 387PX;
						background-color: #FFFAF7;
						overflow: hidden;
						box-sizing: border-box;
						padding: 10px 20px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						cursor: pointer;

						.top_day {
							width: 73px;
							height: 16px;
							line-height: 16px;
							font-size: 16px;
							font-family: PingFang SC;
							font-size: 24px;
							font-weight: 600;
							line-height: 16px;
							letter-spacing: 0em;
							color: #000000;
							position: relative;

							span {
								position: absolute;
								top: 0;
								z-index: 2;
							}

							.day_bottom {
								z-index: 1;
								position: absolute;
								bottom: -4px;
								width: 100%;
								height: 8px;
								background: #B5D9F7;
								border-radius: 121px;
							}
						}

						.center_title {

							width: 100%;
							height: 40px;
							font-family: PingFang SC;
							font-size: 14px;
							font-weight: 600;
							line-height: 20px;
							text-align: justify;
							/* 浏览器可能不支持 */
							letter-spacing: 0.1em;
							color: #000000;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							/* 限制在一个块元素显示的文本的行数 */
							/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
							-webkit-line-clamp: 2;
							/* 设置或检索伸缩盒对象的子元素的排列方式 */
							-webkit-box-orient: vertical;

						}

						.center_title:hover {
							color: #C91C1C;
							font-weight: 800;
						}

						.bottom_content {
							width: 100%;
							height: 46px;
							border-top: 1px solid #ECEEF4;
							box-sizing: border-box;
							padding-top: 6px;
							font-family: PingFang SC;
							font-size: 12px;
							font-weight: normal;
							line-height: 20px;
							text-align: justify;
							/* 浏览器可能不支持 */
							letter-spacing: 0px;
							color: #666666;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							/* 限制在一个块元素显示的文本的行数 */
							/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
							-webkit-line-clamp: 2;
							/* 设置或检索伸缩盒对象的子元素的排列方式 */
							-webkit-box-orient: vertical;


						}


					}
				}
			}

			//党建百科 
			.home_djbk {
				width: 387px;
				height: 100%;

				// 党建百科
				.dangjian_right_content {
					box-sizing: border-box;
					margin-top: 20px;
					position: relative;
					width: 100%;
					height: 280px;
					background: #FAFDFF;
					padding: 10px 0 10px 0;
					display: flex;
					flex-direction: column;
					cursor: pointer;

					.dangjian_right_content_pic {
						position: absolute;
						right: -84px;
						bottom: 0px;
						/* bottom: 0;    */
						width: 260px;
						height: 268px;
						z-index: 100;

						img {
							width: 100%;
							height: 100%;
						}

					}

					.dangjian_right_content_item {
						box-sizing: border-box;
						height: 40px;
						width: 100%;
						font-family: PingFangSC-Regular;
						font-size: 14px;
						font-weight: normal;
						letter-spacing: 0px;
						color: #000000;
						line-height: 40px;
						padding-left: 20px;
						margin-bottom: 5px;
						display: flex;
						align-items: center;

						.left_icon {
							width: 4px;
							height: 8px;
							border-radius: 93px;
							opacity: 1;
							background: #C81C1D;
							margin-right: 10px;
						}

					}

					.dangjian_right_content_item:hover {
						background-color: #C81C1D;
						color: #fff;

						.left_icon {
							background-color: #fff;
						}
					}
				}


			}
		}

		.newest {
			width: 100%;
			margin-top: 30px;

			.newest_content {
				width: 100%;
				height: 193px;
				display: flex;
				margin-top: 20px;

				.dataList_item {
					width: 224px;
					height: 190px;
					margin-bottom: 20px;
					margin-right: 20px;
					cursor: pointer;

					.dataList_item_top_img {
						height: 126px;
						width: 224px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.dataList_item_bottom {
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						width: 100%;
						height: 64px;
						border: 1px solid #ECEEF4;
						padding: 10px;

						.dataList_item_bottom_top_title {
							width: 100%;
							height: 20px;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							font-family: PingFangSC-Medium;
							font-size: 14px;
							font-weight: 800;
							line-height: 20px;
							color: #000000;
						}

						.dataList_item_bottom_top_title:hover {
							color: #C9010A;
						}

						.dataList_item_bottom_botom {
							height: 16px;
							width: 100%;
							display: flex;
							justify-content: space-between;

							.dataList_item_bottom_botom_item {
								overflow: hidden;
								height: 100%;
								width: 74px;
								display: flex;
								justify-content: center;
								align-items: center;

								.dataList_item_bottom_botom_item_icon {
									height: 12px;
									width: 12px;
									margin-right: 2px;
									position: relative;
									display: flex;
									align-items: center;

									img {
										width: 100%;
										height: auto;
									}
								}

								.dataList_item_bottom_botom_item_content {
									font-family: PingFangSC-Regular;
									font-size: 12px;
									font-weight: normal;
									letter-spacing: 0em;
									color: #999999;
								}
							}



						}
					}


				}

				.dataList_item:nth-child(5n) {
					margin-right: 0;

				}

			}
		}


		// 共建共享
		.PartyBuilding {
			width: 100%;
			margin-top: 30px;

			.PartyBuilding_content {
				margin-top: 20px;
				width: 100%;
				height: 200px;
				display: flex;
				justify-content: space-between;

				.PartyBuilding_content_item {
					height: 200px;
					width: 154px;
					border: 1px solid #ECEEF4;
					background: #FFFFFF;
					border-radius: 10px;
					padding: 26px 17px;

					.PartyBuilding_content_item_topImg {
						width: 100%;
						height: 111px;

						img {
							width: 100%;
							height: 100%;
						}
					}

					.PartyBuilding_content_item_title {
						width: 100%;
						height: 22px;
						margin-top: 22px;
						text-align: center;
						font-family: PingFangSC-Regular;
						font-size: 16px;
						font-weight: normal;
						text-align: center;
						letter-spacing: 0px;
						color: #000000;
					}
				}

				.PartyBuilding_content_item:hover {
					box-shadow: 0px 7px 29px 0px rgba(100, 100, 111, 0.2);

					.PartyBuilding_content_item_title {
						font-weight: 800;
					}
				}
			}

		}

		// 党务公开及通知公告
		.OpenAndAnnouncement {
			margin-top: 30px;
			width: 100%;
			// height: 257px;
			display: flex;
			justify-content: space-between;

			.Open {
				width: 793px;
				height: 100%;

			}

			// 通知公告
			.Announcement {
				width: 387px;
				height: 100%;

				.Announcement_content {
					margin-top: 20px;

					.Announcement_content_item {
						height: 40px;
						width: 384px;
						display: flex;
						align-items: center;
						justify-content: space-between;

						.left_circle {
							height: 8px;
							width: 8px;
							border-radius: 50%;
							background-color: #EE632B;
						}

						.center_title {
							font-family: PingFangSC-Regular;
							font-size: 14px;
							font-weight: 400;
							line-height: 20px;
							letter-spacing: 0px;
							color: #000000;
							margin-right: 40px;
							overflow: hidden;
							height: 20px;
							width: 237px;
							text-overflow: ellipsis;
							white-space: nowrap;
						}

						.center_title:hover {
							color: #EE632B;
							font-weight: 800;
						}

						.right_time {
							font-family: MicrosoftYaHei;
							font-size: 12px;
							font-weight: normal;
							line-height: 20px;
							text-align: right;
							letter-spacing: 0px;
							color: #999999;
						}
					}
				}

			}
		}

	}
}
</style>
